<template lang='pug'>
  .missions-frame
    .missions-frame__header
      img.missions-frame__logo(:src="data.icon" :alt="data.title")
      .missions-frame__header-buttons
        button.missions-frame__header-button(v-t="'settings'")
        button.missions-frame__header-button FAQ
        button.missions-frame__header-button(v-t="'support'")
    .missions-frame__body(v-if="offerwallData")
      .missions-frame__offers
        .missions-frame__offer(v-for="offer in offers" :key="offerId(offer)")
          img.missions-frame__offer-logo(:src="offerIcon(offer)")
          .missions-frame__offer-body
            .missions-frame__offer-body-name {{ offerName(offer) }}
            .missions-frame__offer-body-description(v-html="offerDescription(offer)")
          Button.missions-frame__offer-button(is-primary @click="openOffer(offer)") {{ offerButtonText(offer) }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CurrencyService from '@/services/CurrencyService'

export default {
  name: 'MissionsFrame',
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      offerwallData: undefined,
      country: '',
      adToGameDescriptions: {
        9133: 'Register, download game, kill at least 1 player, win 5 battles',
        9134: 'Register, download game, kill at least 1 player, play 15 battles',
        9135: 'Register, download game, kill at least 1 player, win 5 battles',
        9136: 'Register, download game, kill at least 1 player, win 5 battles'
      }
    }
  },

  computed: {
    ...mapState('user', ['user']),

    offers () {
      switch (this.data.name) {
        case 'ayet-studios':
          return this.offerwallData?.offers.slice(0, 100)
        case 'lootably':
          return this.offerwallData?.data.filter(item => item.countries.includes(this.country)).slice(0, 100)
        case 'ovalio':
          return this.offerwallData?.filter(item => item.country === this.country)
        case 'offer-toro':
          return this.offerwallData?.data.slice(0, 100)
        case 'farly':
          return this.offerwallData?.data.slice(0, 100)
        case 'ad-to-game':
          return this.offerwallData?.offers.filter((offer) => {
            // console.log('offer: ', offer, offer.relationship?.custom_payout_settings?.entries, offer.relationship?.custom_payout_settings?.entries?.find((entry) => {
            //   return !!(entry.relationship?.ruleset?.countries?.find((country) => {
            //     return country.country_code === this.country
            //   }))
            // }))
            return !!(offer.relationship?.ruleset?.countries?.find(country => country.country_code === this.country))
          }).slice(0, 100)
        case 'ad-gate-media':
          return this.offerwallData?.data.filter(offer => offer.geo_targeting?.countries.map(country => country.country_code).includes(this.country)).slice(0, 100)
        default:
          return []
      }
    }
  },

  mounted () {
    if (['lootably', 'ad-to-game', 'ad-gate-media', 'ovalio'].includes(this.data.name)) {
      this.loadCountryCode()
    }
    CurrencyService.getCurrencies(this.$axios)
    this.loadOffers()
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    loadOffers () {
      this.data.offerwallDataFunc(this.$axios, this.user?.id || 0)
        .then((response) => {
          this.offerwallData = response.data
        })
    },

    async loadCountryCode () {
      const country = await this.$axios.get(`https://api.country.is/?timestamp=${new Date().getTime()}`)
      this.country = country?.data?.country
    },

    offerId (offer) {
      return offer.id
    },

    offerIcon (offer) {
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.icon
        case 'lootably':
          return offer.image
        case 'offer-toro':
          return offer.image_url_220x124
        case 'farly':
          return offer.icone
        case 'ad-to-game':
          return offer.thumbnail_url
        case 'ad-gate-media':
          return offer.creatives?.icon
        case 'ovalio':
          return offer.icon
        default:
          return ''
      }
    },

    offerName (offer) {
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.name
        case 'lootably':
          return offer.name
        case 'offer-toro':
          return offer.offer_name
        case 'farly':
          return offer.name
        case 'ad-to-game':
          return offer.name.replace(/\[.*\]/, '')
        case 'ad-gate-media':
          return offer.name
        case 'ovalio':
          return offer.name
        default:
          return ''
      }
    },

    offerDescription (offer) {
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.description
        case 'lootably':
          return offer.description
        case 'ovalio':
          return offer.short_description
        case 'offer-toro':
          return offer.offer_desc
        case 'farly':
          return offer.small_description
        case 'ad-to-game':
          if (this.adToGameDescriptions[offer.network_offer_id]) {
            return this.adToGameDescriptions[offer.network_offer_id].slice(0, 100)
          }
          return offer.html_description
        case 'ad-gate-media':
          return offer.description
        default:
          return ''
      }
    },

    offerFullDescription (offer) {
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.conversion_instructions_long
        case 'lootably':
          return offer.description
        case 'ovalio':
          return offer.description
        case 'offer-toro':
          return offer.offer_desc + '<br/><br/>' + offer.disclaimer
        case 'farly':
          return offer.small_description_html + (offer.small_description_html.trim().length ? '<br /><br />' : '') + offer.actions.map(action => action.html + ` +${action.amount} G-Cash`).join('<br /><br />')
        case 'ad-to-game':
          if (this.adToGameDescriptions[offer.network_offer_id]) {
            return this.adToGameDescriptions[offer.network_offer_id]
          }
          return offer.html_description
        case 'ad-gate-media':
          return offer.description + '<br/><br/>' + offer.requirements
        default:
          return ''
      }
    },

    offerButtonText (offer) {
      let sum
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.payout_name
        case 'lootably':
          return `+ ${(offer.currencyReward / 100).toFixed(2)} G-Cash`
        case 'ovalio':
          return `+ ${(offer.payout / 2).toFixed(2)} ${offer.currency}`
        case 'offer-toro':
          return `+ ${offer.amount.toFixed(2)} G-Cash`
        case 'farly':
          return `+ ${offer.reward_amount} G-Cash`
        case 'ad-to-game':
          sum = (offer.relationship?.payouts?.entries?.map(entry => entry.payout_amount)).reduce((a, b) => a + b, 0) * 0.65
          if (offer.currency_id === 'RUB') {
            sum = CurrencyService.convertRUBToEUR(sum).toFixed(2)
          }
          return `+ ${sum} G-Cash`
        case 'ad-gate-media':
          return `+ ${offer.epc} G-Cash`
        default:
          return ''
      }
    },

    offerLink (offer) {
      switch (this.data.name) {
        case 'ayet-studios':
          return offer.tracking_link
        case 'lootably':
          return offer.link.replace('{userID}', `${this.user.id}`)
        case 'ovalio':
          return `${offer.click_url}&sub1=MPIF&sub2=${this.user.id}&aff_clickid=${this.user.id}_${+new Date()}`
        case 'offer-toro':
          console.log('offer.offer_url', offer.offer_url, this.user.id, `${this.user.id}`)
          return offer.offer_url.replace('[USER_ID]', `${this.user.id}`)
        case 'farly':
          console.log('url:', offer.link + `/?clickid=${this.user.id}&sub=3014`)
          return offer.link + `/?clickid=${this.user.id}&sub=3014`
        case 'ad-to-game':
          return `${offer.tracking_url}?sub1=${this.user.id}`
        case 'ad-gate-media':
          return offer.click_url.replace('s1=', `s1=${this.user.id}`)
        default:
          return ''
      }
    },

    openOffer (offer) {
      this.showModal({
        component: 'ModalMessage',
        data: {
          title: this.offerName(offer),
          type: 'info',
          text: this.offerFullDescription(offer),
          buttons: [
            {
              props: { isPrimary: true },
              title: this.$t('startMission'),
              action: () => {
                location.href = this.offerLink(offer)
              }
            }
          ]
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
.missions-frame {
  &__header {
    display: none;

    @media (min-width: $breakpointTablet) {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 24px;
      background-color: $blue-grey60;
      border-radius: 16px;
    }

    &-buttons {
      display: none;

      @media (min-width: $breakpointDesktopWide) {
        display: grid;
        grid-template-columns: repeat(3, max-content);
        grid-gap: 16px;
      }
    }

    &-button {
      padding: 12px 24px;
      border: 2px solid $blue-grey05;
      border-radius: 8px;
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      color: $white;
      background-color: transparent;
    }
  }

  &__logo {
    height: 50px;
  }

  &__body {
    margin-top: 40px;
  }

  &__offers {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }

  &__offer {
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-gap: 16px;
    align-items: center;
    background-color: $blue-grey60;
    padding: 16px;
    border-radius: 16px;
    width: 100%;
    overflow: hidden;

    @media (min-width: $breakpointDesktop) {
      grid-template-columns: max-content 1fr max-content;
    }

    &-button {
      grid-column-start: 1;
      grid-column-end: 3;
      width: 100%;

      @media (min-width: $breakpointDesktop) {
        grid-column: auto;
      }
    }

    &-logo {
      height: 64px;
      width: 64px;
    }

    &-body {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      color: $white;
      width: 100%;
      overflow: hidden;

      &-name {
        font-weight: 500;
        font-size: 18px;
        line-height: 22px;
        width: 100%;
        overflow: hidden;
      }

      &-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        width: 100%;
        overflow: auto;
      }
    }
  }
}
</style>
